import React, { Component } from "react";
import {
  RaisedButton,
  RefreshIndicator,
  Paper,
  Divider,
  SelectField,
  MenuItem,
  Snackbar,
} from "material-ui";

import ClientSearch from "../clients/ClientSearch";

const style = {
  container: {
    position: "relative",
  },
  refresh: {
    display: "inline-block",
    position: "relative",
  },
};
const LoadingIndicator = () => (
  <RefreshIndicator
    size={60}
    left={70}
    top={0}
    loadingColor="#FF9800"
    status="loading"
    style={style.refresh}
  />
);

export default class DocumentGenerator extends Component {
  state = {
    showLayer: false,
    showSnackbar: false,
    loading: false,
    documentType: "",
    documentLink: "",
  };

  getStyles() {
    return {
      center: {
        textAlign: "center",
      },
      paper: {
        width: "96%",
        margin: 30,
        textAlign: "center",
      },
      refresh: {
        display: "inline-block",
        position: "relative",
      },
    };
  }

  render() {
    let { showLayer, documentType, loading, showSnackbar, documentLink } =
      this.state;
    let { paper, center, refresh } = this.getStyles();

    return (
      <Paper
        className="container"
        zDepth={2}
        style={{ marginTop: "2em", paddingTop: "1em", paddingBottom: "1em" }}
      >
        <h3>Document Generator</h3>
        <br />
        <Divider />
        <SelectField
          floatingLabelText="Document Type"
          fullWidth={true}
          onChange={this.handleChange}
          value={documentType}
        >
          <MenuItem
            value="Business Checklist"
            primaryText="Business Checklist"
          />
          <MenuItem
            value="Individual Checklist"
            primaryText="Individual Checklist"
          />
        </SelectField>
        {loading ? <LoadingIndicator /> : null}

        <RaisedButton
          label="Select Client"
          primary={true}
          onTouchTap={this.openLayer}
        />
        <ClientSearch
          open={showLayer}
          close={this.closeLayer}
          onSelect={this.handleClientSelection}
        />
        <Snackbar
          open={showSnackbar}
          message={<a href={documentLink}>Download</a>}
        />
      </Paper>
    );
  }

  // Modal Methods
  openLayer = () => {
    this.setState({ showLayer: true });
  };

  closeLayer = () => {
    this.setState({ showLayer: false });
  };

  handleClientSelection = (selected) => {
    let { documentType } = this.state;

    this.setState({ loading: true }, function () {
      if (documentType == "Business Checklist") {
        this.genBusinessChecklist(selected);
      } else {
        this.genIndividualChecklist(selected);
      }
    });

    this.closeLayer();
  };
  // Modal Methods

  handleChange = (e, i, val) => {
    this.setState({ documentType: val });
  };

  genBusinessChecklist = (client) => {
    let url = "/api/pdf/business_checklist";
    let options = {
      method: "POST",
      headers: {
        token: this.props.token.jwt,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ client }),
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) return res.json();
      })
      .then((json) => {
        this.setState({
          loading: false,
          showSnackbar: true,
          documentLink: json.Location,
        });
      });
  };

  genIndividualChecklist = (client) => {
    let url = "/api/pdf/individual_checklist";
    let options = {
      method: "POST",
      headers: {
        token: this.props.token.jwt,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ client }),
    }
      .then((res) => {
        if (res.status >= 200 && res.status < 300) return res.json();
      })
      .then((json) => {
        this.setState({
          loading: false,
          showSnackbar: true,
          documentLink: json.Location,
        });
      });
  };
}



// WEBPACK FOOTER //
// ./app/components/documents/DocumentGenerator.js